<template>
  <q-layout view="hHh lpr fff">
    <q-header elevated class="bg-primary text-white">
      <q-toolbar>
        <q-btn
          v-if="showBack"
          flat
          round
          dense
          icon="arrow_back"
          @click="goBack"
          class="q-mr-sm"
        />
        <q-toolbar-title>
          {{ displayTitle }}
        </q-toolbar-title>
        
        <q-space />
      </q-toolbar>
    </q-header>

    <q-page-container>
      <q-page class="flex">
        <ViewerPageComponent :dxfUrl="dxfUrl" :showLayers="showLayers">
          <div v-if="!dxfUrl" class="centralMessage row justify-center items-center">
            <div class="col-auto text-center">
              <q-icon name="description" size="4rem" color="grey-6" class="q-mb-md"/>
              <div class="text-h5 text-grey-7 q-mb-md">DXF 查看器</div>
              <div class="text-body1 text-grey-6 q-mb-lg">
                请在URL中添加参数来加载DXF文件
              </div>
              
              <div class="text-body2 text-grey-7 q-mb-md text-left">
                <div class="q-mb-sm"><strong>必需参数：</strong></div>
                <div class="q-mb-sm">• <code>dxfUrl</code> - DXF文件的URL地址</div>
                
                <div class="q-mb-sm q-mt-md"><strong>可选参数：</strong></div>
                <div class="q-mb-sm">• <code>title</code> - 自定义页面标题</div>
                <div class="q-mb-sm">• <code>showLayer</code> - 显示图层控制面板 (true/false)</div>
              </div>
              
              <div class="text-caption text-grey-5 q-mb-sm">
                <div class="q-mb-xs"><strong>基础示例:</strong></div>
                <div class="q-mb-sm"><code>?dxfUrl=https://example.com/file.dxf</code></div>
                
                <div class="q-mb-xs"><strong>显示图层控制:</strong></div>
                <div class="q-mb-sm"><code>?dxfUrl=https://example.com/file.dxf&showLayer=true</code></div>
                
                <div class="q-mb-xs"><strong>完整示例:</strong></div>
                <div><code>?dxfUrl=https://example.com/file.dxf&title=我的图纸&showLayer=true</code></div>
              </div>
              
              <div class="text-caption text-orange-7">
                注意：DXF文件需要与当前域名同源，或服务器配置了正确的CORS头
              </div>
            </div>
          </div>
        </ViewerPageComponent>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import ViewerPageComponent from '@/components/ViewerPage'

export default {
  name: 'ViewerPage',
  components: {
    ViewerPageComponent
  },
  data() {
    return {
      dxfUrl: null,
      customTitle: null,
      showLayers: false,
      showBack: true
    }
  },
  computed: {
    displayTitle() {
      // 优先使用自定义标题
      if (this.customTitle) {
        return this.customTitle
      }
      
      // 如果没有加载DXF文件，显示默认标题
      if (!this.dxfUrl) return 'DXF 查看器'
      
      // 从URL中提取文件名作为标题
      try {
        const url = new URL(this.dxfUrl)
        const pathname = url.pathname
        const fileName = pathname.split('/').pop()
        // 如果文件名存在且有扩展名，返回文件名；否则返回默认标题
        if (fileName && fileName.includes('.')) {
          return fileName
        }
        return 'DXF文件'
      } catch {
        return 'DXF文件'
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    _SetExternalUrl(url) {
      // 直接使用传入的URL，不依赖第三方CORS代理
      this.dxfUrl = url
    }
  },
  mounted() {
    const dxfUrl = this.$route.query.dxfUrl
    const title = this.$route.query.title
    const showLayer = this.$route.query.showLayer
    const showBack = this.$route.query.showBack
    
    // 设置自定义标题
    if (title?.length) {
      this.customTitle = decodeURIComponent(title)
    }
    
    // 设置图层面板显示状态
    if (showLayer !== undefined) {
      this.showLayers = showLayer === 'true' || showLayer === '1'
    }
    
    // 设置是否显示后退按钮
    if (showBack !== undefined) {
      this.showBack = showBack === 'true' || showBack === '1'
    }
    
    // 设置DXF文件URL
    if (dxfUrl?.length) {
      if (!URL.canParse(dxfUrl)) {
        this.$q.notify({
          type: "negative",
          message: "无效的URL地址"
        })
        return
      }
      this._SetExternalUrl(dxfUrl)
    }
  }
}
</script>

<style scoped>
.full-height {
  height: calc(100vh - 50px);
}

.flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.centralMessage {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
  background-color: white;
}

code {
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
}
</style>